import React from 'react';
import { ChefHat } from 'lucide-react';

export const ChefPickBadge = ({ testId, label = 'Kokin suositus' }) => (
  <span
    className="inline-flex items-center gap-1 text-[9px] md:text-[10px] font-bold uppercase tracking-wider text-white bg-gradient-to-r from-[#C97A2B] to-[#B65A3A] px-2 py-0.5 rounded-full shadow-sm"
    data-testid={testId}
  >
    <ChefHat className="w-3 h-3" /> {label}
  </span>
);

export default ChefPickBadge;
